import { Box, styled, Typography } from '@mui/material';
import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useResponsive } from 'src/hooks/useResponsive';
import { isDefined, isEmptyString, isNotNull, isNumber } from 'lib/typeInference';
import { useTranslation } from 'react-i18next';
import { MenuSearchButton } from 'components/menu/MenuSearchButton';
import { useQuery } from 'src/hooks/useQuery';
import { SuggestionsProvider } from 'src/hooks/useSuggestionsContext';
import { MenuSearch } from 'components/menu/MenuSearchDialog';

const StyledBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isDesktop'
})<{ isDesktop: boolean }>(({ theme, isDesktop }) => ({
    backgroundColor: theme.palette.titleTextColour,
    borderRadius: isDesktop ? theme.shape.borderRadius : 0,
    width: '100%',
    padding: theme.spacing(1),
    color: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(1.5)
}));

const StyledRow = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(1)
}));

interface MenuDeliveryInfoProps {
    deliveryTimeMins?: number;
    title?: string;
}

export const MenuDeliveryInfo: React.FC<MenuDeliveryInfoProps> = ({ deliveryTimeMins, title }) => {
    const { isDesktop } = useResponsive();
    const { t } = useTranslation();
    const currentSearch = useQuery('search');
    const [openMenuSearch, setOpenMenuSearch] = React.useState(() => {
        if (isNotNull(currentSearch) && isDefined(currentSearch) && !isEmptyString(currentSearch)) {
            return true;
        }
        return false;
    });

    const handleCloseMenuSearch = React.useCallback(() => {
        setOpenMenuSearch(false);
    }, []);
    const handleOpenMenuSearch = React.useCallback(() => {
        setOpenMenuSearch(true);
    }, []);
    if (!isNumber(deliveryTimeMins)) {
        return null;
    }
    return (
        <StyledBox isDesktop={isDesktop}>
            <Box>
                <Typography sx={{ fontWeight: 700 }} align="center">
                    {title}
                </Typography>
                <StyledRow>
                    <AccessTimeIcon sx={{ mr: 1 }} />
                    <Typography>
                        {t('DELIVERY_ETA_MESSAGE', {
                            time: `${deliveryTimeMins} minute${deliveryTimeMins === 1 ? '' : 's'}`
                        })}
                    </Typography>
                </StyledRow>
            </Box>
            <MenuSearchButton handleOpenMenuSearch={handleOpenMenuSearch} />
            {!!openMenuSearch && (
                <SuggestionsProvider>
                    <MenuSearch open={openMenuSearch} onClose={handleCloseMenuSearch} />
                </SuggestionsProvider>
            )}
        </StyledBox>
    );
};
